import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_NewDiscussion.scss';
import { ModuleFE_Discussion } from '@app/hcs-frontend';
import { DiscussionType_Chat } from '@app/hcs-shared/_entity/discussion/consts';
export class Renderer_NewDiscussion extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.discussionLabel = ModuleFE_Discussion.getLabelFromEntityId(nextProps.type, nextProps.refId);
        if (this.state?.discussionLabel !== state.discussionLabel)
            state.discussionText = '';
        return state;
    }
    saveDiscussion = async () => {
        await ModuleFE_Discussion._v1.createNewDiscussion({
            toCreateTopic: {
                type: this.props.type,
                refId: this.props.refId,
            },
            toCreateDiscussion: {
                type: DiscussionType_Chat,
            },
            toCreateMessage: {
                type: 'text',
                text: this.state.discussionText.trim(),
            }
        }).executeSync();
    };
    render() {
        return _jsxs(LL_V_L, { className: 'new-discussion', children: [_jsx("div", { className: 'new-discussion__title', children: this.state.discussionLabel }), _jsx(TS_TextArea, { type: 'text', value: this.state.discussionText, onChange: value => this.setState({ discussionText: value }) }), _jsx(Button, { variant: 'primary', onClick: this.saveDiscussion, children: "Save" })] });
    }
}
//# sourceMappingURL=Renderer_NewDiscussion.js.map